import { useSearchParams } from 'next/navigation';

// The param is spelled out again in the park page and footer links, which live in apps that do not
// depend on this one, so keep the three in step.
const usePrintRequested = (): boolean => {
  const searchParams = useSearchParams();

  return searchParams.get('print') === 'true';
};

export default usePrintRequested;
